/** @format */

import React from "react";

const SingleInfo = ({ icon, label, description }) => {
  return (
    <div className="single__info">
      <div className="single__info__icon">{icon}</div>
      <div className="single__info__container">
        <div className="single__info__label">{label}</div>
        <div className="single__info__text">{description}</div>
      </div>
    </div>
  );
};

export default SingleInfo;
